export const checkboxTheme = {
  root: {
    width: '{size.pixel.18}',
    height: '{size.pixel.18}',
    checkedBackground: '{sd.primary.color}',
    checkedHoverBackground: '{sd.primary.hover}',
    checkedBorderColor: '{sd.primary.color}',
    checkedHoverBorderColor: '{sd.primary.hover}',
    disabledCheckedBackground: '{sd.primary.disabled}',
    disabledCheckedBorderColor: '{sd.primary.disabled}'
  }
  // extend: {
  //   colorScheme: {
  //     light: {
  //       checked: {
  //         hover: {
  //           background: '{sd.primary.hover}',
  //           borderColor: '{override.primary.color}'
  //         },
  //         background: '{sd.primary.color}'
  //       }
  //     }
  //   }
  // }
};
